import React from 'react';
import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';
import { If, Then, Else } from 'react-if'

import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx"
import ReactAudioPlayer from 'react-audio-player';
import SubmissionDetailMindMap from "composer/views/retriever/SubmissionDetailMindMap.jsx"

import {
  Icon,
  Chip,
  Avatar,
  GridList,
  GridListTile,
  GridListTileBar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';

import {
  grey,
  green,
  red,
} from '@material-ui/core/colors'

const answerDefaultColor = grey[600]
const answerCorrectColor = green[600]
const answerWrongColor = red[600]

class SubmissionDetailContent extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      answerData: this.props.answerData,
      componentData: this.props.componentData,
    };
    autoBind(this);
  }

  mcText(kind) {
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_TEXTS) {
      return;
    }

    return this.mcTextMulti(Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI);
  }

  mcTextMulti(kind) {
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI) {
      return;
    }

    let ans0, ans1, ans2, ans3;
    let correct0, correct1, correct2, correct3;
    // let payload = JSON.parse(this.state.componentData.payload);
    let payload = '';
    try{
      payload = JSON.parse(this.state.componentData.payload.replace(/[\n\r]/g, ''));
    }
    catch(err){
      console.log('the following payload causes the error:');
      for (let i = 0; i < this.state.componentData.payload.length; i++) {
        console.log(i.toString()+': '+this.state.componentData.payload[i].charCodeAt(0) + ' ,' + this.state.componentData.payload[i]);
      }
      console.log(err);
    }
    ans0 = (payload.ans0 != null? payload.ans0 : "");
    ans1 = (payload.ans1 != null? payload.ans1 : "");
    ans2 = (payload.ans2 != null? payload.ans2 : "");
    ans3 = (payload.ans3 != null? payload.ans3 : "");
    correct0 = (payload.correct0 != null? payload.correct0 : false);
    correct1 = (payload.correct1 != null? payload.correct1 : false);
    correct2 = (payload.correct2 != null? payload.correct2 : false);
    correct3 = (payload.correct3 != null? payload.correct3 : false);

    // MC with single correct answer always assume the first answer
    if (payload.correct0 == null) {
      correct0 = true;
    }

    let ansArr = [ans0, ans1, ans2, ans3];
    let correctAnwser = [correct0, correct1, correct2, correct3];
    let userAnswer = this.state.answerData.answer.split(',');

    return (
      <div>
        {ansArr.map( (row, i) => {
          let resultBG = answerDefaultColor;
          if (correctAnwser[i]) {
            resultBG = answerCorrectColor;
          }
          else if (userAnswer.includes(i.toString())) {
            resultBG = answerWrongColor;
          }

          return (
            <Chip
              style={{margin:"0 12px 0 0", background:resultBG, color:'White'}}
              avatar={
                <Avatar style={{background:resultBG}}>
                  <Icon style={{color:'White'}}>{correctAnwser[i]? "check_circle": "highlight_off"}</Icon>
                </Avatar>
              }
              label={row + (userAnswer.includes(i.toString())? " [User's choice]" : "")}
            />
          );
        })}
      </div>
    );
  }

  fillInTheBlank(kind) {
    if (kind != Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK) {
      return;
    }

    // let payload = JSON.parse(this.state.componentData.payload);
    let payload = '';
    try{
      payload = JSON.parse(this.state.componentData.payload.replace(/[\n\r]/g, ''));
    }
    catch(err){
      console.log('the following payload causes the error:');
      for (let i = 0; i < this.state.componentData.payload.length; i++) {
        console.log(i.toString()+': '+this.state.componentData.payload[i].charCodeAt(0) + ' ,' + this.state.componentData.payload[i]);
      }
      console.log(err);
    }
    let textBefore = (payload.text1 != null? payload.text1 : "");
    let textAfter = (payload.text2 != null? payload.text2 : "");
    return (
        textBefore + " ( ... ) " + textAfter
    );
  }

  customTable(kind) {
    if (kind != Config.HOTSPOT_CONTENT_TABLE_AND_CELL) {
      return;
    }

    let answer = [];
    if (this.state.answerData.answer != "") {
      answer = JSON.parse(this.state.answerData.answer);
      console.log("answer:", answer);
    }
  
    let payload = '';
    try{
      payload = JSON.parse(this.state.componentData.payload.replace(/[\n\r]/g, ''));
    }
    catch(err){
      console.log('the following payload causes the error:');
      for (let i = 0; i < this.state.componentData.payload.length; i++) {
        console.log(i.toString()+': '+this.state.componentData.payload[i].charCodeAt(0) + ' ,' + this.state.componentData.payload[i]);
      }
      console.log(err);
    }
    let columns=[], rows=[];
    if (payload != null) {
      columns = (payload.column_names != null? payload.column_names.split(',') : []);
      rows = (payload.row_names != null? payload.row_names.split(',') : []);
      console.log("col:", columns);
      console.log("row:", rows);
    }

    return (
      <Table padding="normal" border="1px" size="small">
        <TableHead>
          <TableRow style={{backgroundColor:grey[200]}}>
            <TableCell></TableCell>
            {
              columns.map( (column, i) => {
                return (
                  <TableCell key={i}>
                    {column}
                  </TableCell>
                )
              })
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map( (row, i) => {
              console.log('------');
              return (
                <TableRow key={i}>
                  <TableCell style={{backgroundColor:grey[200]}}>
                    {row}
                  </TableCell>
                  {
                    columns.map( (dummy, j) => {
                      console.log('i'+i.toString() + ' ' + 'j'+j.toString());
                      return (
                        <TableCell key={j}>
                          {answer[columns.length * i + j]}
                        </TableCell>
                      )
                    })
                  }
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    );
  }

  mcPic(kind) {
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_PICTURES) {
      return;
    }

    return this.mcPicMulti(Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI);
  }

  mcPicMulti(kind) {
    if (kind != Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI) {
      return;
    }

    let payload = JSON.parse(this.state.componentData.payload);

    let correct0, correct1, correct2, correct3;
    correct0 = (payload.correct0 != null? payload.correct0 : false);
    correct1 = (payload.correct1 != null? payload.correct1 : false);
    correct2 = (payload.correct2 != null? payload.correct2 : false);
    correct3 = (payload.correct3 != null? payload.correct3 : false);

    // MC with single correct answer always assume the first answer
    if (payload.correct0 == null) {
      correct0 = true;
    }

    let preview0, preview1, preview2, preview3;
    preview0 = (payload.picture0 != null? Config.UPLOAD_PATH() + payload.picture0.tn_path : "");
    preview1 = (payload.picture1 != null? Config.UPLOAD_PATH() + payload.picture1.tn_path : "");
    preview2 = (payload.picture2 != null? Config.UPLOAD_PATH() + payload.picture2.tn_path : "");
    preview3 = (payload.picture3 != null? Config.UPLOAD_PATH() + payload.picture3.tn_path : "");

    let previewArr = [preview0, preview1, preview2, preview3];
    let correctAnwser = [correct0, correct1, correct2, correct3];
    let userAnswer = this.state.answerData.answer.split(',');

    return (
      <div style={{maxWidth:"100%"}}>
        <GridList
          style={{flex:"1", overflow:'auto'}}
        >
          {previewArr.map( (tile, i) => {
            let resultBG = answerDefaultColor;
            if (correctAnwser[i]) {
              resultBG = answerCorrectColor;
            }
            else if (userAnswer.includes(i.toString())) {
              resultBG = answerWrongColor;
            }

            let marginRight = (userAnswer.includes(i.toString())? "12px" : "0px");

            return (
              <GridListTile key={i}>
                <img alt="" src={tile}/>
                <GridListTileBar
                  title={
                    <Chip
                      style={{marginRight:marginRight, background:resultBG, color:'White'}}
                      avatar={
                        <Avatar style={{background:resultBG}}>
                          <Icon style={{color:'White'}}>{correctAnwser[i]? "check_circle": "highlight_off"}</Icon>
                        </Avatar>
                      }
                      label={(userAnswer.includes(i.toString())? " [User's choice]" : "")}
                    />
                  }
                />
              </GridListTile>
            );
          })}
        </GridList>
      </div>
    );
  }

  mindMap(kind) {
    if (kind != Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP) {
      return;
    }

    return (
      <SubmissionDetailMindMap root={this.props.root} parent={this}
        componentData={this.props.componentData}
      />
    );
  }

  render() {
    let kind = parseInt(this.state.answerData.kind);
    let name = (this.state.componentData.name != null? this.state.componentData.name : "");
    let content = (this.state.componentData.content != null? this.state.componentData.content : "");

    if (name == "") {
      name = Config.GET_HOTSPOT_CONTENT_CONFIG(kind).title;
    }

    return (
      <div>
        <Switch condition={kind}>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_TEXTS}>
            {this.mcText(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_PICTURES}>
            {this.mcPic(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI}>
            {this.mcTextMulti(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI}>
            {this.mcPicMulti(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_QUESTION}>
            {this.state.answerData.answer}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK}>
            {this.state.answerData.answer}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP}>
            {this.mindMap(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_TAKE_PHOTO}>
            <If condition={this.state.answerData.path != ""}>
              <Then>
                <img alt="" src={Config.UPLOAD_PATH() + this.state.answerData.path} width="auto" height="450px"/>
              </Then>
              <Else>
                <span style={{color:answerWrongColor}}>{Localization.strings.NO_PHOTO}</span>
              </Else>
            </If>
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_TABLE_AND_CELL}>
            {this.customTable(kind)}
          </Case>
          <Case value={Config.HOTSPOT_CONTENT_TAKE_RECORD}>
            <If condition={this.state.answerData.path != ""}>
              <Then>
                <ReactAudioPlayer
                  src={Config.UPLOAD_PATH() + this.state.answerData.path}
                  autoPlay={false}
                  loop={false}
                  controls={true}
                  preload={"auto"}
                />
              </Then>
              <Else>
                <span style={{color:answerWrongColor}}>{Localization.strings.NO_RECORDING}</span>
              </Else>
            </If>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default SubmissionDetailContent;
